import { ActionType } from 'typesafe-actions';

import { ProductData } from '../product/types';

import * as actions from './actions';

export type AuthAction = ActionType<typeof actions>;

/**

 * Action types

 */

export enum AuthActionTypes {
  SIGN_IN_REQUEST = '@auth/SIGN_IN_REQUEST',

  SIGN_IN_SUCCESS = '@auth/SIGN_IN_SUCCESS',

  SIGN_IN_FAILURE = '@auth/SIGN_IN_FAILURE',

  SIGN_IN_SOCIAL_REQUEST = '@auth/SIGN_IN_SOCIAL_REQUEST',

  SIGN_IN_SOCIAL_FAILURE = '@auth/SIGN_IN_SOCIAL_FAILURE',

  SIGN_IN_SOCIAL_SUCCESS = '@auth/SIGN_IN_SOCIAL_SUCCESS',

  SIGNOUT_REQUEST = '@auth/SIGNOUT_REQUEST',

  SIGNOUT_REQUEST_SUCESS = '@auth/SIGNOUT_REQUEST_SUCESS',

  PAYMENT_REQUEST = '@auth/PAYMENT_REQUEST',

  PAYMENT_SEL_REQUEST = '@auth/PAYMENT_SEL_REQUEST',

  PAYMENT_REMOVE_REQUEST = '@auth/PAYMENT_REMOVE_REQUEST',

  ADDRESS_REQUEST = '@auth/ADDRESS_REQUEST',

  ADDRESS_SUCCESS = '@auth/ADDRESS_SUCCESS',

  ADDRESS_SELECTED_REQUEST = '@auth/ADDRESS_SELECTED_REQUEST',

  ADDRESS_REMOVED_REQUEST = '@auth/ADDRESS_REMOVED_REQUEST',

  ADDRESS_REMOVED_SUCCESS = '@auth/ADDRESS_REMOVED_SUCCESS',

  CARD_ESITEF_REQUEST = '@auth/CARD_ESITEF_REQUEST',

  CARD_ESITEF_SUCCESS = '@auth/CARD_ESITEF_SUCCESS',

  CARD_ESITEF_ERROR = '@auth/CARD_ESITEF_ERROR',

  CARD_LIST_REQUEST = '@auth/CARD_LIST_REQUEST',

  CARD_LIST_SUCCESS = '@auth/CARD_LIST_SUCCESS',

  CUSTOMER_CLEAR = '@auth/CUSTOMER_CLEAR',

  CUSTOMER_SET_STEP = '@auth/CUSTOMER_SET_STEP',

  CUSTOMER_CREATE_REQUEST = '@auth/CUSTOMER_CREATE_REQUEST',

  CUSTOMER_CREATE_SUCCESS = '@auth/CUSTOMER_CREATE_SUCCESS',

  CUSTOMER_IS_EXIST = '@auth/CUSTOMER_IS_EXIST',

  CUSTOMER_UPDATE_REQUEST = '@auth/CUSTOMER_UPDATE_REQUEST',

  CUSTOMER_UPDATE_SUCCESS = '@auth/CUSTOMER_UPDATE_SUCCESS',

  CUSTOMER_UPDATE_METHODS_SUCCESS = '@auth/CUSTOMER_UPDATE_METHODS_SUCCESS',

  CUSTOMER_UPDATE_ADDRESS_SUCCESS = '@auth/CUSTOMER_UPDATE_ADDRESS_SUCCESS',

  CUSTOMER_UPDATE_FAILURE = '@auth/CUSTOMER_UPDATE_FAILURE',

  CUSTOMER_SEND_MAIL = '@auth/CUSTOMER_SEND_MAIL',

  CUSTOMER_CONFIRM_MAIL = '@auth/CUSTOMER_CONFIRM_MAIL',

  CUSTOMER_CONFIRM_MAIL_SUCCESS = '@auth/CUSTOMER_CONFIRM_MAIL_SUCCESS',

  CUSTOMER_CEP_REQUEST = '@auth/CUSTOMER_CEP_REQUEST',

  CUSTOMER_CEP_SUCCESS = '@auth/CUSTOMER_CEP_SUCCESS',

  CUSTOMER_CEP_CLEAR = '@auth/CUSTOMER_CEP_CLEAR',

  CUSTOMER_CREATE_ADDRESS_REQUEST = '@auth/CUSTOMER_CREATE_ADDRESS_REQUEST',

  CUSTOMER_CREATE_ADDRESS_SUCCESS = '@auth/CUSTOMER_CREATE_ADDRESS_SUCCESS',

  CUSTOMER_GET_ADDRESS_SUCCESS = '@auth/CUSTOMER_GET_ADDRESS_SUCCESS',

  CUSTOMER_FORGOT_PASS = '@auth/CUSTOMER_FORGOT_PASS',

  CUSTOMER_FORGOT_PASS_SUCCESS = '@auth/CUSTOMER_FORGOT_PASS_SUCCESS',

  CUSTOMER_FORGOT_PASS_CLEAR = '@auth/CUSTOMER_FORGOT_PASS_CLEAR',

  CUSTOMER_FAVORITE_SAVE = '@auth/CUSTOMER_FAVORITE_SAVE',

  CUSTOMER_FAVORITE_SAVE_SUCCESS = '@auth/CUSTOMER_FAVORITE_SAVE_SUCCESS',

  CUSTOMER_FAVORITE_LIST = '@auth/CUSTOMER_FAVORITE_LIST',

  CUSTOMER_FAVORITE_LIST_SUCCESS = '@auth/CUSTOMER_FAVORITE_LIST_SUCCESS',

  CUSTOMER_FAVORITE_REMOVE = '@auth/CUSTOMER_FAVORITE_REMOVE',

  CUSTOMER_AGREEMENT_ACCEPTED = '@auth/CUSTOMER_AGREEMENT_ACCEPTED',

  CUSTOMER_AGREEMENT_ACCEPTED_SUCCESS = '@auth/CUSTOMER_AGREEMENT_ACCEPTED_SUCCESS',

  CUSTOMER_AGREEMENT_REQUEST = '@auth/CUSTOMER_AGREEMENT_REQUEST',

  CUSTOMER_AGREEMENT_REQUEST_SUCCESS = '@auth/CUSTOMER_AGREEMENT_REQUEST_SUCCESS',

  CLEAR_MESSAGE = '@auth/CLEAR_MESSAGE',

  CLEAR_LOADING = '@auth/CLEAR_LOADING',

  VERIFY_CUSTOMER_IS_EXIST = '@auth/VERIFY_CUSTOMER_IS_EXIST',

  VERIFY_CUSTOMER_IS_EXIST_SUCESS = '@auth/VERIFY_CUSTOMER_IS_EXIST_SUCESS',

  VERIFY_EMAIL_EXIST = '@auth/VERIFY_EMAIL_EXIST',

  VERIFY_EMAIL_EXIST_SUCCESS = '@auth/VERIFY_EMAIL_EXIST_SUCESS',

  VERIFY_EMAIL_EXIST_ERROR = '@auth/VERIFY_EMAIL_EXIST_ERROR',

  UPDATE_CUSTOMER_CREATE = '@auth/UPDATE_CUSTOMER_CREATE',

  REMOVE_ACCOUNT_CUSTOMER = '@auth/REMOVE_ACCOUNT_CUSTOMER',

  CUSTOMER_RESET_PASS = '@auth/CUSTOMER_RESET_PASS', //reset senha

  CUSTOMER_RESET_PASS_SUCCESS = '@auth/CUSTOMER_FORGOT_PASS_SUCCESS', // reset senha sucesso

  RESET_LOGOUT = '@auth/RESET_LOGOUT',
}

export interface UserAddressShipping {
  id?: number;

  carrier?: string;

  carrier_title?: string;

  method?: string;

  method_title?: string;

  is_scheduled?: boolean;

  method_description?: string;

  price?: number;

  price_with_return?: number;

  formated_price?: string;

  base_price?: number;

  formated_base_price?: string;

  delivery_time?: string;

  days_opened: Array<string>;

  max_delivery_days: number;

  opening_hours: string;

  closing_hours: string;

  chosen_shipping_date?: string;
}

export interface UserAddresses {
  shipping_method?: 'shipment' | 'store';

  cart_id?: string;

  address_type?: 'customer' | 'guest';

  address_id?: string;

  id: number;

  address_name?: string;

  name?: string;

  first_name?: string;

  last_name?: string;

  company_name?: string;

  address?: string;

  number?: string;

  neighborhood?: string;

  complement?: string;

  city?: string;

  state?: string;

  country?: string;

  country_name?: string;

  postcode?: string;

  reference?: string;

  phone_area_code?: string;

  phone?: string;

  selected?: number;

  default_address?: boolean;

  latitude?: string;

  longitude?: string;

  shipping?: UserAddressShipping;
}

export interface User {
  data: CustomerData;

  avatar?: string;

  addresses?: UserAddresses[];

  methods?: UserCard[];

  favorite?: ProductData[];
}

export interface ReactCreditCardProps {
  id: number;

  name: string;

  number: string;

  expiration: string;

  cvc: string;

  cardLastFour: string;

  customer_doc: string;

  type: string;
}

export interface UserCard {
  id?: number;

  method?: string;

  full_name?: string;

  expiration?: string;

  cvc?: string;

  media_id?: number;

  selected?: number;

  tef_nita?: string;

  tef_token?: string;

  card_number?: string;

  card_last_four?: string;

  card_brand?: string;

  expiry_date: string;

  authorizer_id?: string;

  merchant_usn?: string;

  customer_id?: string;

  type?: string;

  security_code?: string;

  customer_doc?: string;
}

export interface UserCardSplit {
  value: string;

  label: string;
}

export interface CustomerData {
  first_name?: string;

  last_name?: string;

  email?: string;

  password?: string;

  password_confirm?: string;

  cpf_cnpj?: string;

  birth?: string;

  date_of_birth?: string;

  phone_mobile?: string;

  genre?: string;

  avatar?: string;

  customer_id?: string;

  gender?: string;

  phone?: string;

  new_password?: string;

  new_password_confirmation?: string;

  dataRes?: CustomerData;

  conf_code?: string;

  id?: string;

  status?: number;

  verified?: number;

  is_verified?: number;

  seller?: number;
}

export type UserCreate = Omit<
  CustomerData,
  | 'cpf_cnpj'
  | 'phone_mobile'
  | 'avatar'
  | 'new_password'
  | 'new_password_confirmation'
  | 'dataRes'
  | 'conf_code'
  | 'id'
  | 'status'
  | 'verified'
  | 'seller'
>;

export enum AuthActionStep {
  CST_STEP_01 = 'CST_STEP_01',

  CST_STEP_02 = 'CST_STEP_02',

  CST_STEP_03 = 'CST_STEP_03',

  CST_STEP_04 = 'CST_STEP_04',
}

export interface iPassword {
  email: string;
}

export interface AgreementsProps {
  id: string;

  content: string;
}

export interface AuthState {
  readonly loadingSignInRequest: boolean;

  readonly loading?: boolean;

  readonly isSignedIn: boolean;

  readonly isLoginInGoogle?: boolean;

  readonly isCreateAddress: boolean;

  readonly agreement?: boolean;

  readonly agreements?: AgreementsProps;

  readonly error: boolean;

  readonly message?: string;

  readonly user: User;

  readonly userCreate: UserCreate;

  readonly step?: AuthActionStep;

  readonly mailConfirm?: boolean;

  readonly address?: UserAddresses;

  readonly socialRegisterPass?: boolean;

  readonly forgotPasswordReq: boolean;

  readonly forgotPasswordOk: boolean;

  readonly passwordMessage?: string;

  readonly loadingResetPassRequest: boolean;

  readonly resetPasswordReq: boolean;

  readonly resetPasswordOk: boolean;

  readonly emailExists?: boolean;

  readonly isLogout: boolean;
}
